import React from 'react'

import { Select, SelectOption, SelectPlaceholder } from '../../../../components/select'
import { SelectListProps } from '../../../../components/select/select-list'
import { TRANSACTION_LABEL } from '../../constants/general'
import { PortfolioTransaction } from '../../types'
import { usePortfolioBulkEditRowContext } from '../PortfolioBulkEditRowContext'
import { EditColumnProps } from './types'

const TRANSACTION_OPTIONS = Object.entries(TRANSACTION_LABEL)
  .filter(([transaction]) => parseInt(transaction) !== PortfolioTransaction.Watch)
  .map(([value, label]) => ({ value: Number(value), label }))

interface TransactionEditColumnProps<StateType, ErrorsType> extends EditColumnProps<StateType, ErrorsType> {
  transactions?: typeof TRANSACTION_OPTIONS
  optionListProps?: Omit<SelectListProps, 'items' | 'selectedIndex' | 'onChange' | 'state'>
}

export function TransactionEditColumn<
  StateType extends {
    transaction?: number
  },
  ErrorsType extends {
    transaction?: boolean
  },
>({
  transactions = TRANSACTION_OPTIONS,
  optionListProps = { className: 'min-w-28' },
  ...props
}: TransactionEditColumnProps<StateType, ErrorsType>) {
  const { isActive, setIsInteracting } = usePortfolioBulkEditRowContext()

  return (
    <>
      <input form={props.form} type="hidden" value={props.entry.transaction} />
      {isActive ? (
        <Select
          aria-label="Transaction"
          className={props.className}
          label={props.label}
          isHorizontalLabel={props.isHorizontalLabel}
          labelClassName={props.labelClassName}
          value={props.entry.transaction}
          items={transactions}
          onChange={(item) => props.setState((entry) => ({ ...entry, transaction: item.value }))}
          listProps={optionListProps}
          size={props.size}
          data-testid="transaction-select"
          onIsInteractingChange={setIsInteracting}
        >
          {transactions.map((item) => (
            <SelectOption key={item.value} data-testid={`transaction-option-${item.value}`}>
              {item.label}
            </SelectOption>
          ))}
        </Select>
      ) : (
        <SelectPlaceholder
          className={props.className}
          size={props.size}
          buttonContent={
            transactions.find(({ value }) => value === props.entry.transaction)?.label ?? transactions[0].label
          }
        />
      )}
    </>
  )
}
